import AccordionBox from "../../../../../../components/AccordionBox";
import {
  RazorDateTime,
  RazorImageFallback,
  RazorTable,
  RazorTableRow,
} from "../../../../../../components/razor-reuse";
import CurrencyText from "../../../../../../components/fragment/cur-text/CurrencyText";
import ZoomableImage from "../../../../../../components/fragment/image/zoomable-image";
import { useOverviewContext } from "../../../CustomerSingle";
import { useSelector } from "react-redux";
import RootState from "../../../../../../redux/type";
import {
  detectCloudinaryFileType,
  formatDateToYYYYMMDD,
  getDocumentPreviewUrl,
} from "../../../../../../utils/Helper";

export default function KybAccordion() {
  const context = useOverviewContext();
  const { customer } = useSelector((state: RootState) => state.customer);

  const companyDetails = [
    {
      label: "Country",
      value: customer?.resident_country ? (
        <CurrencyText
          currency={customer?.business?.country?.code}
          url={customer?.business?.country?.flag}
          text={customer?.business?.country?.name}
        />
      ) : (
        "---"
      ),
    },
    { label: "Company Name", value: customer?.business?.business_name || "" },
    {
      label: "Registration Number",
      value: customer?.business?.registration_number || "",
    },
    {
      label: "Entity Type",
      value: customer?.business?.business_type || "",
    },
    {
      label: "Legal Address",
      value:
        customer?.business?.details?.legal_address ||
        customer?.business?.address?.street ||
        "",
    },
    { label: "State", value: customer?.business?.address?.state || "" },
    { label: "City", value: customer?.business?.address?.town || "" },
    {
      label: "Postal Code",
      value: customer?.business?.address?.postCode || "",
    },
    { label: "Tax ID", value: customer?.business?.details?.tax_id || "" },
  ];

  const headerList = [
    "First Name",
    "Last Name",
    "Email",
    "Date of Birth",
    "TIN",
    "Share Size",
  ];

  const availableUBOs = customer?.business?.beneficial_owners?.filter(
    (chi: any) => chi?.types?.includes("ubo"),
  ) || [{ name: "" }];

  const availableShareholders = customer?.business?.beneficial_owners?.filter(
    (chi: any) => chi?.types?.includes("shareholder"),
  ) || [{ name: "" }];

  const availableDirectors = customer?.business?.beneficial_owners?.filter(
    (chi: any) => chi?.types?.includes("director"),
  ) || [{ name: "" }];

  return (
    <>
      <AccordionBox defaultState={false} title="KYB INFORMATION">
        <main className="bg-white min-h-[500px] p-[24px] space-y-[18px]">
          <div className="flex w-full gap-x-[20px]">
            <div className="border border-[#e6e6e6] rounded-lg py-[14px] p-[34px] flex-1">
              <h6 className="text-[14px] font-medium text-gray-01 mb-[20px]">
                Company Data
              </h6>
              <div className="grid gap-y-[20px] gap-x-[12px] grid-cols-2 mt-[20px]">
                {companyDetails.map((chi) => (
                  <div key={chi.label} className="space-y-2">
                    <h5 className="text-[12px] text-[#758089]">{chi.label}:</h5>
                    <p className="text-[#596080] font-medium text-[14px] flex items-center [&_svg]:size-[12px] [&_svg]:mr-[4px]">
                      {chi.value || "---"}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="border border-[#e6e6e6] rounded-lg pb-[60px]">
            <div className="flex justify-between items-center border-[#e6e6e6] border-b py-[14px] px-[35px]">
              <p className="text-gray-01 text-[14px] font-medium">
                Company Documents
              </p>
            </div>
            {/* Current upload */}
            <div className=" mt-[8px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-[30px] justify-around">
                {customer?.documents?.length === 0 ? (
                  <div className="space-y-[8px] mx-auto">
                    <div className="w-[350px] h-[250px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box">
                      <RazorImageFallback loadSize={45} url={" "}>
                        <figure className="size-full text-gray-02">
                          No file found
                        </figure>
                      </RazorImageFallback>
                    </div>
                    <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                      <p className="">No upload</p>
                      <p className="inline-flex items-center">
                        Date Uploaded: ---
                      </p>
                    </div>
                  </div>
                ) : (
                  customer?.documents?.map((item: any, idx: number) => (
                    <div key={idx} className="space-y-[8px] mx-auto">
                      {detectCloudinaryFileType(item?.file_path?.[1]) !==
                        "image" ||
                      item?.metadata?.fileType === "pdf" ||
                      item?.file_path?.[1]?.includes("/raw") ? (
                        <div className="h-[260px] w-[285px] bg-gray-03 grid place-content-center overflow-hidden text-center">
                          <a
                            href={getDocumentPreviewUrl(
                              item?.file_path?.[1],
                              detectCloudinaryFileType(item?.file_path?.[1]) ===
                                "pdf" || item?.metadata?.fileType === "pdf",
                            )}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <span className="text-gray-01 underline cursor-pointer">
                              Click to preview
                            </span>

                            <br />
                            <span className="text-gray-01 underline cursor-pointer">
                              {item?.metadata?.fileName ||
                                item?.document_sub_type}
                            </span>
                          </a>
                        </div>
                      ) : (
                        <ZoomableImage
                          src={item?.file_path?.[1]}
                          alt={item?.document_type}
                          width={400}
                          height={450}
                          zoomLevel={1.3}
                          zoomWindowSize={400}
                          onClick={() => {
                            context?.setDocumentModal({
                              visible: true,
                              url: item?.file_path?.[1],
                              doc_name: item?.metadata?.fileName,
                              file_name: item?.document_type,
                              file_sizee: item?.metadata?.fileSize,
                              status: item?.status,
                              date: item?.updated_at,
                            });
                          }}
                          containerClassName="w-[350px] h-[250px] bg-gray-03 grid place-content-center overflow-hidden profile-img-box"
                        />
                      )}
                      <div className="text-gray-02 text-[12px] space-y-[12px] mt-8">
                        <p className="">
                          {item?.document_sub_type?.replace("_", " ")}
                        </p>
                        <p className="inline-flex items-center">
                          Date Uploaded:{" "}
                          {
                            <RazorDateTime
                              date={item?.updated_at}
                              hideAgo
                              className="[&_span]:!text-[14px] [&_span]:ml-[4px] [&_span]:!text-gray-01"
                            />
                          }
                        </p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

          <div className="border border-[#e6e6e6] rounded-lg pb-[60px]">
            <div className="flex justify-between items-center border-[#e6e6e6] border-b py-[14px] px-[35px]">
              <p className="text-gray-01 text-[14px] font-medium">
                Associated Parties
              </p>
            </div>
            <div className="px-[20px] mt-[20px]">
              <p className="text-[12px] text-[#758089] font-medium mb-[14px]">
                UBOs
              </p>
              <RazorTable headerList={headerList}>
                {availableUBOs?.map((chi: any, idx: any) => {
                  return (
                    <RazorTableRow
                      key={idx}
                      one={chi?.first_name || "---"}
                      two={chi?.last_name || "---"}
                      three={chi?.email || "---"}
                      four={
                        chi?.birth_date
                          ? formatDateToYYYYMMDD(chi?.birth_date)
                          : "---"
                      }
                      five={chi?.tin || "---"}
                      six={chi?.shareSize ? `${chi?.shareSize}%` : "---"}
                    />
                  );
                })}
              </RazorTable>
            </div>

            <div className="px-[20px] mt-[30px]">
              <p className="text-[12px] text-[#758089] font-medium mb-[14px]">
                Shareholders
              </p>
              <RazorTable headerList={headerList}>
                {availableShareholders?.map((chi: any, idx: any) => {
                  return (
                    <RazorTableRow
                      key={idx}
                      one={chi?.first_name || "---"}
                      two={chi?.last_name || "---"}
                      three={chi?.email || "---"}
                      four={
                        chi?.birth_date
                          ? formatDateToYYYYMMDD(chi?.birth_date)
                          : "---"
                      }
                      five={chi?.tin || "---"}
                      six={chi?.shareSize ? `${chi?.shareSize}%` : "---"}
                    />
                  );
                })}
              </RazorTable>
            </div>

            <div className="px-[20px] mt-[30px]">
              <p className="text-[12px] text-[#758089] font-medium mb-[14px]">
                Directors
              </p>
              <RazorTable headerList={headerList}>
                {availableDirectors?.map((chi: any, idx: any) => {
                  return (
                    <RazorTableRow
                      key={idx}
                      one={chi?.first_name || "---"}
                      two={chi?.last_name || "---"}
                      three={chi?.email || "---"}
                      four={
                        chi?.birth_date
                          ? formatDateToYYYYMMDD(chi?.birth_date)
                          : "---"
                      }
                      five={chi?.tin || "---"}
                      six={chi?.shareSize ? `${chi?.shareSize}%` : "---"}
                    />
                  );
                })}
              </RazorTable>
            </div>
          </div>
        </main>
      </AccordionBox>
    </>
  );
}
